import { render, staticRenderFns } from "./TaxonomyInfoForm.vue?vue&type=template&id=61e37d9c&scoped=true&"
import script from "./TaxonomyInfoForm.vue?vue&type=script&lang=js&"
export * from "./TaxonomyInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyInfoForm.vue?vue&type=style&index=0&id=61e37d9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e37d9c",
  null
  
)

export default component.exports